export const LABELS: {
	[key:string]: string;
} = {
	'CLOSED_PERMANENTLY': 'Dauerhaft geschlossen',
	'CLOSED_TEMPORARILY': 'Vorübergehend geschlossen',
	'OPERATIONAL': 'Normal geöffnet',
	'IS_OPEN': 'Jetzt geöffnet',
	'IS_CLOSED': 'Im Moment geschlossen',
};

export const getLabel = (key: string) => LABELS[key] || '';
